import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';

// Anyone with an admin-surface role (admin, foreman, bookkeeper) can reach
// /admin/*. The AdminLayout's tab strip + each page's content further
// gate by specific capability. Crew (or emulated crew) bounces to /clock.
export default function AdminRoute() {
  const { isAdminSurface } = useAuth();
  if (!isAdminSurface) return <Navigate to="/clock" replace />;
  return <Outlet />;
}
